import {Toast} from 'vant';
import axios from 'axios';
import qs from 'qs';
import Utils from "./Utils";
import wx from "weixin-js-sdk";
const login=(data)=>{
    console.log('returnObject', data.returnObject)
    let app = Utils.getApp();
    if (app == 'WeiXinMini')
    {
        Toast.loading({
            duration: 500,
            forbidClick: true,
        });
        wx.miniProgram.navigateTo({
            url: '/pages/oauth/oauth',
            complete: () => {
                Toast.clear();
            }
        });

        // let returnurl=window.location.origin+'/#/minioauthredirect';
        // let url=data.returnObject.replace('.return_url.',encodeURIComponent(returnurl));
        // console.log(url);
        // wx.miniProgram.navigateTo({
        //     url: '/pages/oauth/ofa?src='+encodeURIComponent(url),
        //     complete: () => {
        //         Toast.clear();
        //     }
        // });

    }
    else if(app=='WeiXin')
    {
        let returnurl=window.location.href;
        let hostname=returnurl;
        let search='';
        if(returnurl.indexOf('?')!=-1)
        {
            let urls=returnurl.split('?');
            hostname=urls[0];
            search=urls[1];
        }
        console.log('returnurl',returnurl)
        console.log('hostname',hostname)
        console.log('search',search)
        let url=data.returnObject.replace('.return_url.',encodeURIComponent(hostname+(search?'?'+encodeURIComponent(search):'')));
        console.log(url);
        //window.location.href=url;
        if(returnurl.indexOf('/position')>0)
        {
            window.location.href=('/#/nologin?returnurl='+encodeURIComponent(url));
        }
        else {
            window.location.replace('/#/nologin?returnurl=' + encodeURIComponent(url));
        }
        return false;
    }
    else
    {
        let returnurl=window.location.href;
        let hostname=returnurl;
        let search='';
        if(returnurl.indexOf('?')!=-1)
        {
            let urls=returnurl.split('?');
            hostname=urls[0];
            search=urls[1];
        }
        console.log('returnurl',returnurl)
        console.log('hostname',hostname)
        console.log('search',search)
        let url=data.returnObject+encodeURIComponent(hostname+(search?'?'+encodeURIComponent(search):''));
        console.log('url',url)
        //window.location.href=url;
        if(returnurl.indexOf('/position')>0)
        {
            window.location.href=('/#/nologin?returnurl='+encodeURIComponent(url));
        }
        else {
            window.location.replace('/#/nologin?returnurl=' + encodeURIComponent(url));
        }
        return false;
    }
}
let Request={};
Request.request = (url, data) => {
    let param=Utils.getParams();
    if(param && param.token) {
        axios.defaults.headers.common["token"] = param.token;
    }
    axios.defaults.withCredentials=true;//允许携带cookie
    if(!data)
    {
        data={};
    }
    if(!data.app)
    {
        let app = Utils.getApp();
        data.app = app.indexOf("WeiXin") != -1 ? "WeiXin" : "M";
    }
    return axios.post(url,qs.stringify(data),{
        header:{
            'Accept': 'application/json',
            'Content-Type':'multipart/form-data'
        }
    })
    .then(res=>{
        console.log(res)
        let data=res.data;
        if (data.status === 1)
        {
            return (data.returnObject);
        }
        else
        {
            if(data.code==403)
            {
                console.log('returnObject', data.returnObject)
                login(data);
            }
            if (data.info !== '') {
                Toast(data.info);
            }
            return false;
        }
    })
    .catch(Error=> {
        console.log(Error)
        Toast('网络请求失败');
    });
}
Request.requestJson = (url, data) => {
    let param=Utils.getParams();
    if(param && param.token) {
        axios.defaults.headers.common["token"] = param.token;
    }
    axios.defaults.withCredentials=true;//允许携带cookie
    if(!data)
    {
        data={};
    }
    if(!data.app) {
        let app = Utils.getApp();
        data.app = app.indexOf("WeiXin") != -1 ? "WeiXin" : "M";
    }
    return axios.post(url,data,{
        header:{
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        }
    })
    .then(res=>{
        console.log(res)
        let data=res.data;
        if (data.status === 1)
        {
            return (data.returnObject);
        }
        else
        {
            if(data.code==403)
            {
                console.log('returnObject',data.returnObject)
                login(data);
            }
            if (data.info !== '') {
                Toast(data.info);
            }
            return false;
        }
    })
    .catch(Error=> {
        console.log(Error)
        Toast('网络请求失败');
    });
}
Request.requestFile = (url, file) => {
    let data = new FormData();  // 创建form对象
    data.append('file', file);  // 通过append向form对象添加数据
    axios.defaults.withCredentials=true;//允许携带cookie
    let app = Utils.getApp();
    data.append('app',app.indexOf("WeiXin")!=-1?"WeiXin":"M");
    return axios({
        url:url,
        data:data,
        dataType: 'json',
        method: 'post',
        header:{
            'Content-Type':'multipart/form-data'  //如果写成contentType会报错
        }
    })
    .then(res=>{
        console.log(res)
        let data=res.data;
        if (data.status === 1)
        {
            return (data.returnObject);
        }
        else
        {
            if (data.info !== '') {
                Toast(data.info);
            }
            return false;
        }
    })
    .catch(Error=> {
        console.log(Error)
        Toast('网络请求失败');
    });
}
export default Request;



